/**
 * Validates if a string passes the provided length restrictions. Meant to be used with react-hook-form.
 * @param value a valid string
 * @param param1.min provide the minimum string length
 * @param param1.max provide the maximum string length
 * @returns boolean true if validation passed, error message otherwise
 */

export function validateLength(
  value: string,
  { min, max }: { min?: number; max?: number }
) {
  if (min !== undefined && value.length < min) {
    return `Answer must be greater than ${min} characters.`;
  }

  if (max !== undefined && value.length > max) {
    return `Answer must be fewer than ${max} characters.`;
  }

  return true;
}
